module.exports = __webpack_public_path__ + "img/qrcode.4ec8dab6.jpg";